import { GlTab, GlTabs } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import CiResourceComponents from './ci_resource_components.vue?vue3';
import CiResourceReadme from './ci_resource_readme.vue?vue3';
export default {
    name: 'CiResourceDetails',
    components: {
        CiResourceReadme,
        CiResourceComponents,
        GlTab,
        GlTabs
    },
    componentStyles: [
        'gl-mt-3'
    ],
    props: {
        resourcePath: {
            type: String,
            required: true
        },
        version: {
            type: String,
            required: true
        }
    },
    i18n: {
        tabs: {
            components: s__('CiCatalog|Components'),
            readme: s__('CiCatalog|Readme')
        }
    }
};
